import { motion } from "framer-motion";

// One slow editorial marquee. Duplicated content for a seamless loop.
export default function Marquee({ items, bg = "#12263A", color = "#F3F2F2", speed = 26 }) {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y-2 border-[#12263A] py-5 select-none" style={{ backgroundColor: bg }}>
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: speed, ease: "linear", repeat: Infinity }}
      >
        {row.map((it, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span
              className="text-[26px] md:text-[40px] font-black px-6"
              style={{ color, letterSpacing: "-0.02em" }}
            >
              {it}
            </span>
            <Spark color={color} />
          </span>
        ))}
      </motion.div>
    </div>
  );
}

function Spark({ color }) {
  return (
    <svg width="22" height="22" viewBox="0 0 100 100" className="shrink-0" aria-hidden="true">
      <path d="M50 4 L58 42 L96 50 L58 58 L50 96 L42 58 L4 50 L42 42 Z" fill={color} />
    </svg>
  );
}
